var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMbhomebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 513,
    viewBox: "0 0 241 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.05 186.277C578.757 177.252 569.065 166.238 553.496 158.521L553.402 158.466C522.866 143.161 472.115 142.482 427.309 183.118L300.177 301.854C300.155 301.849 300.141 301.858 300.136 301.88C273.476 326.925 240.385 339.27 207.405 341.879L200.425 342.459C199.74 342.5 199.047 342.528 198.344 342.541C163.402 342.53 128.416 331.211 99.4478 306.549C88.4279 297.176 87.1173 280.632 96.5239 269.619C105.897 258.6 122.448 257.255 133.461 266.662C151.907 282.406 174.203 289.908 197.385 290.114L203.256 289.648C226.026 287.842 247.426 279.483 264.259 263.647L264.34 263.595L391.69 144.661C391.776 144.586 391.862 144.511 391.948 144.436C452.862 89.0691 527.016 86.607 576.863 111.614C600.844 123.532 622.233 143.364 631.32 168.417C641.217 195.741 634.941 225.433 609.752 248.657C599.098 258.46 582.517 257.804 572.714 247.151C562.904 236.53 563.56 219.95 574.22 210.113C584.406 200.7 584.492 193.058 582.05 186.277Z",
    fill: "url(#paint0_linear_139_7)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.248 316.287C224.255 330.735 212.491 342.471 198.009 342.471C163.068 342.46 128.074 331.174 99.1466 306.486C41.2446 257.171 29.5842 171.162 71.8864 107.747L71.9006 107.68L207.25 -94.3086C215.3 -106.344 231.585 -109.564 243.62 -101.514C255.623 -93.4709 258.842 -77.1859 250.792 -65.1501L115.484 136.812L115.477 136.845C87.7989 178.359 95.6632 234.668 133.126 266.592C151.871 282.574 174.523 290.047 198.03 290.042C212.504 290.075 224.248 301.806 224.248 316.287Z",
    fill: "url(#paint1_linear_139_7)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.101 211.867C621.264 222.142 621.198 238.744 610.916 248.941C588.857 270.766 544.517 312.831 505.929 349.227L434.078 416.715C434.073 416.738 434.057 416.757 434.03 416.775C378.595 469.074 291.92 472.023 233.582 423.279C204.382 398.883 187.348 366.3 181.488 331.824C181.354 331.143 181.254 330.457 181.191 329.767L180.577 322.781C177.646 289.837 184.251 255.142 204.481 224.638C212.472 212.555 228.737 209.261 240.787 217.244C252.864 225.268 256.157 241.534 248.174 253.584C235.4 272.87 230.734 295.315 232.781 318.102L233.315 323.986C237.422 346.791 248.554 367.487 267.176 383.058C304.959 414.63 361.818 412.899 398.098 378.636L398.187 378.549L469.964 311.08C450.666 329.295 483.103 298.797 469.964 311.08C508.68 274.572 552.538 232.964 574.027 211.682C584.31 201.485 600.904 201.584 611.101 211.867Z",
    fill: "url(#paint2_linear_139_7)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.252 353.43C194.849 354.706 182.106 344.058 180.83 329.655L180.209 322.702C177.244 289.751 183.849 255.056 204.08 224.552C204.085 224.53 204.087 224.519 204.087 224.519L299.758 79.193C332.281 28.2154 323.092 -21.6943 302.849 -49.2233L302.71 -49.3927C293.12 -62.6945 280.934 -70.0417 271.237 -71.6482C263.368 -72.9711 255.413 -71.094 247.963 -60.3998C239.7 -48.5143 223.365 -45.5504 211.479 -53.8133C199.594 -62.0762 196.663 -78.4048 204.926 -90.2903C223.931 -117.662 252.026 -128.06 279.953 -123.349C306.057 -118.954 329.354 -102.005 345.142 -80.1797C378.161 -35.244 388.18 38.2432 343.847 107.593C343.779 107.695 343.71 107.797 343.642 107.899L247.827 253.404L247.78 253.464C235.005 272.751 230.366 295.236 232.413 318.023L233.034 324.976C234.31 339.378 223.695 352.128 209.252 353.43Z",
    fill: "url(#paint3_linear_139_7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_7",
    x1: 198.074,
    y1: 314.85,
    x2: 217.246,
    y2: -66.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DD8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_7",
    x1: 198.074,
    y1: 314.851,
    x2: 217.246,
    y2: -66.7889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DD8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E87E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_139_7",
    x1: 586.54,
    y1: 229.173,
    x2: 243.501,
    y2: 230.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3458FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#806CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B982FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_139_7",
    x1: 214.696,
    y1: 258.535,
    x2: 306.757,
    y2: 102.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A77F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE9F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 581.651,
    height: 561.807,
    fill: "white",
    transform: "translate(117.35 -157.981) rotate(12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbhomebg);
export default __webpack_public_path__ + "static/media/mbhomebg.119c44e171c652c798a93f560ef6bab5.svg";
export { ForwardRef as ReactComponent };